// extracted by mini-css-extract-plugin
export default {"hideTooltip":"E9-z","fadeIn":"F9-z","delay":"G9-z","recommendedSizeTooltip":"H9-z"};